import { OrderPlanningProfile } from "./OrderPlanningProfile";
import { AutogenLayoutOrderPlanningProfileFilter } from "./autogen/AutogenLayoutOrderPlanningProfileFilter";

export class OrderPlanningProfileFilter extends AutogenLayoutOrderPlanningProfileFilter {
  override onLoad() {
    (this.layoutProfile as OrderPlanningProfile).textboxTitle.required = false;
    this.layoutProfile.textboxDefaultView.visible = false;
  }
}
